/// *** System import ***///
import { Component } from '@angular/core';
import { ViewController, ToastController } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../../../app/globals';
import { Market_SessionStore } from '../../session.store';

@Component({
  selector: 'page-market-session-sort',
  templateUrl: 'sort.html',
})
export class Market_SessionSortPopover {
  /// *** Data ***///
  private sortField: string;
  private isDescSort: boolean;
  constructor(
    // *** System
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    // *** Custom 
    private globals: Globals,
    private store: Market_SessionStore) {
    this.sortField = this.store.params.sortField;
    this.isDescSort = this.store.params.isDescSort;
  }

  // *** Fermer la fenêtre et retourner les paramètres de tri
  private _dismiss() {
    try {
      this.store.params.sortField = this.sortField;
      this.store.params.isDescSort = this.isDescSort;
      this.viewCtrl.dismiss();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.viewCtrl.dismiss();
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/market/session/popovers/sort/sort.ts